import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 61"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.743 60.383q1.992.351 3.75-.703l41.25-24.375q1.875-1.055 2.52-2.93t0-3.75c-.645-1.875-1.27-2.226-2.52-2.93L8.493 1.32Q6.852.265 4.86.56a5.75 5.75 0 0 0-3.398 1.758Q.056 3.781.056 6.125v48.75q0 2.109 1.347 3.633a5.65 5.65 0 0 0 3.34 1.875"
    }, null, -1)
  ]))]))
}
export default { render: render }